import axios from 'axios'

export const HttpConfig = {
  responseType: 'json',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

const responseErrorInterceptor = errorConfig => {
  console.error(errorConfig)
  return Promise.reject(errorConfig)
}

const requestErrorInterceptor = errorConfig => {
  console.error(errorConfig)
  return Promise.reject(errorConfig)
}

class HttpProvider {
  static api = axios.create(HttpConfig)

  static get(url, additionalConfig = {}, headers) {
    return HttpProvider.api.get(url, { headers, ...additionalConfig })
  }

  static patch(url, data) {
    return HttpProvider.api.patch(url, data)
  }

  static post(url, data = {}, headers, config) {
    return HttpProvider.api.post(url, data, config ? config : { headers })
  }

  static put(url, data = {}, headers) {
    return HttpProvider.api.put(url, data, { headers })
  }

  static delete(url, data = {}, headers) {
    return HttpProvider.api.delete(url, { headers, data })
  }
}

HttpProvider.api.interceptors.response.use(config => config, responseErrorInterceptor)

HttpProvider.api.interceptors.request.use(config => config, requestErrorInterceptor)

export default HttpProvider

export const formatResponse = response => {
  const { data, status, headers } = response
  return {
    data,
    status,
    headers
  }
}
